export const makeSudoGUID = () => {
    const newGuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    return newGuid;
};

export const isMBSEmployee = (email: string) => {
    if (!email) return false;
    return (
        email.includes("@mbshighway.com") ||
        email.includes("@listreports.com") ||
        email.includes("@highway.ai") ||
        email.includes("@runtime-revolution.com")
    );
};

export function getHost(): string {
    if (typeof window === "undefined") {
        if (process.env["ENVIRONMENT"] === "stage") return "https://stage.mbshighway.com";
        if (process.env["ENVIRONMENT"] === "test") return "https://test.mbshighway.com";
        if (process.env["ENVIRONMENT"] === "development") return "http://localhost:3000";
        return "https://mbshighway.com";
    } else {
        return window.location.origin;
    }
}

// Server-only launch switch for the Agent Portal. Until AGENT_PORTAL_ENABLED is "true", co-brand
// links keep pointing at the legacy realtor site.
export function isAgentPortalEnabled(): boolean {
    return process.env["AGENT_PORTAL_ENABLED"] === "true";
}
